import script from "./MemberStampPanel.vue?vue&type=script&setup=true&lang=ts"
export * from "./MemberStampPanel.vue?vue&type=script&setup=true&lang=ts"

import "./MemberStampPanel.vue?vue&type=style&index=0&id=53cf72b7&lang=scss"

const __exports__ = script;

export default __exports__